
import { defineComponent, computed, ref, reactive } from 'vue'
import { ElForm } from 'element-plus'
import JrDialog from '@/components/jr-parts/JrDialog.vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import JrTextarea from '@/components/jr-parts/JrTextarea.vue'
import { proximityConfirmRule } from '@/constants/rules'

export interface Comment {
  history_comment: string | null
}

export default defineComponent({
  name: 'ConfirmDialog',
  emits: ['update:isSave', 'update:isShow', 'update:comment', 'update:isValid'],
  components: { JrDialog, JrButton, JrTextarea },
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  setup(props, context) {
    const formRef = ref<InstanceType<typeof ElForm>>()
    const isShowDialog = computed(() => {
      return props.isShow === true
    })
    const form = reactive<Comment>({
      history_comment: null,
    })

    const ok = () => {
      if (formRef.value) {
        formRef.value.validate((valid) => {
          if (!valid) {
            // チェックNG
            return false
          } else {
            context.emit('update:comment', form.history_comment)
            context.emit('update:isSave', true)
            close()
          }
        })
      }
    }

    const close = () => {
      context.emit('update:isValid', false)
      context.emit('update:isShow', false)
      return
    }

    return {
      formRef,
      isShowDialog,
      form,
      ok,
      close,
      rules: proximityConfirmRule,
    }
  },
})
